var render, staticRenderFns
import script from "./DragMixin.vue?vue&type=script&lang=ts"
export * from "./DragMixin.vue?vue&type=script&lang=ts"
import style0 from "./DragMixin.vue?vue&type=style&index=0&id=7b419a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b419a8a",
  null
  
)

export default component.exports